import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ValidGradingRankCodeList } from './interface/valid-grading-rank-code.interface';

/**
 * Class to get valid gradingrank list
 */
@Injectable()
export class ValidGradingRankCodeService {
    constructor(private http: HttpClient) {}

    get(): Observable<ValidGradingRankCodeList> {
        return this.http.get<ValidGradingRankCodeList>('/api/validGradingRankCode', {});
    }

    getAll(): Observable<ValidGradingRankCodeList> {
        return this.http.get<ValidGradingRankCodeList>('/api/validGradingRankCode/all', {});
    }

    getAllEnabled(): Observable<ValidGradingRankCodeList> {
        return this.http.get<ValidGradingRankCodeList>('/api/validGradingRankCode/allEnabled', {});
    }

    getAllDisabled(): Observable<ValidGradingRankCodeList> {
        return this.http.get<ValidGradingRankCodeList>('/api/validGradingRankCode/allDisabled', {});
    }
}
